import React from 'react'
import OffersPanel from "./OffersPanel";

function Index(
    {
        expanded,
    }) {
    return (expanded && <OffersPanel/>)
}


export default Index;